class CartPage {
    constructor() {
        this.cart = null;
        this.updateForm = document.querySelector(".cart-page__form");
        this.quantityInputs = document.querySelectorAll(
            ".cart-item__quantity-input"
        );
        this.quantityButtons = document.querySelectorAll(
            ".cart-item__quantity-btn"
        );
        this.removeButtons = document.querySelectorAll(".cart-item__remove");
        this.updateGiftStatusButtons = document.querySelectorAll(
            '.cart-item__gift_checkbox input[type="checkbox"]'
        );
        this.updateTimeouts = new Map();
        this.debounceDelay = 800;

        if (!this.updateForm) return;

        this.#fetchCart();
        this.#hideGiftWrapProduct();
        this.#extractVariantData();
        this.#attachEventListeners();
    }

    async #fetchCart() {
        try {
            const response = await fetch("/cart.js");
            this.cart = await response.json();
            console.log(this.cart);
            if (
                this.cart.items.length === 1 &&
                this.cart.items[0].variant_id == window.rpCritical.giftWrapId
            ) {
                await this.#clearCart();
            }
        } catch (err) {
            console.error("error getting cart", err);
        }
    }

    #extractVariantData() {
        const productData = document.querySelector("[data-product-json]");
        if (!productData) return;

        try {
            const product = JSON.parse(productData.textContent);

            for (const variant of product.variants) {
                const cartItem = document.querySelector(
                    `[data-variant-id="${variant.id}"]`
                );
                if (!cartItem) continue;

                const quantityInput = cartItem.querySelector(
                    ".cart-item__quantity-input"
                );
                if (!quantityInput) continue;

                quantityInput.dataset.inventory =
                    variant.inventory_quantity?.toString() || "0";
                quantityInput.dataset.inventoryPolicy =
                    variant.inventory_policy || "deny";
                quantityInput.dataset.inventoryManagement =
                    variant.inventory_management || "shopify";

                if (
                    variant.inventory_management === "shopify" &&
                    variant.inventory_policy !== "continue"
                ) {
                    quantityInput.setAttribute(
                        "max",
                        variant.inventory_quantity || 0
                    );
                } else {
                    quantityInput.removeAttribute("max");
                }
            }
        } catch (error) {
            console.error("Failed to parse product data:", error);
        }
    }

    #attachEventListeners() {
        // Don't intercept checkout form - let it submit normally

        for (const input of this.quantityInputs) {
            input.addEventListener(
                "change",
                this.#handleQuantityChange.bind(this)
            );
            input.addEventListener(
                "input",
                this.#handleQuantityInput.bind(this)
            );
            input.addEventListener("blur", this.#validateQuantity.bind(this));
        }

        for (const button of this.quantityButtons) {
            button.addEventListener(
                "click",
                this.#handleQuantityButton.bind(this)
            );
        }

        for (const button of this.removeButtons) {
            button.addEventListener("click", this.#handleRemoveItem.bind(this));
        }
        for (const checkbox of this.updateGiftStatusButtons) {
            checkbox.addEventListener(
                "change",
                this.#handleUpdateGiftState.bind(this)
            );
        }
    }

    #handleQuantityInput(event) {
        const input = event.target;
        const value = input.value;
        const numericValue = value.replace(/[^0-9]/g, "");

        if (numericValue === "" || parseInt(numericValue) < 1) {
            input.value = "1";
        } else {
            input.value = numericValue;
        }

        this.#updateButtonStates(input);

        const key = input.dataset.key;
        const quantity = parseInt(input.value) || 1;
        this.#debounceUpdate(key, quantity);
    }
     async #handleUpdateGiftState(event) {
        const checkbox = event.target;
        const cartItem = checkbox.closest(".cart-item");
        if (!cartItem) return;

        const key = cartItem.dataset.key;
        const quantityInput = cartItem.querySelector(
            ".cart-item__quantity-input"
        );
        const quantity = parseInt(quantityInput.value) || 1;

        this.#cancelDebounce(key);

        try {
            await this.#updateCartItem(key, quantity, checkbox.checked);
            await this.#fetchCart();
            await this.#updateGiftWrapQuantity();
            window.location.reload();
        } catch (error) {
            console.error("Failed to update gift status:", error);
            this.#showError("Error actualizando la envoltura de regalo");
        }
    }

    #calculateGiftWrapsNeeded() {
        if (!this.cart?.items) return 0;

        return this.cart.items.reduce((total, item) => {
            if (item.variant_id === window.rpCritical.giftWrapId) return total;

            const isGift = item.properties?.Regalo === "Sí";
            return isGift ? total + item.quantity : total;
        }, 0);
    }
    #getNumberOfGiftWraps() {
        if (!this.cart?.items) return 0;

        return this.cart.items.reduce((total, item) => {
            return item.variant_id !== window.rpCritical.giftWrapId
                ? total + item.quantity
                : total;
        }, 0);
    }
    async #updateGiftWrapQuantity() {
        const giftWrapsNeeded = this.#calculateGiftWrapsNeeded();
        const giftWrapInCart = this.cart.items.find(
            (item) => item.variant_id === window.rpCritical.giftWrapId
        );

        if (giftWrapsNeeded === 0) {
            // Remove gift wrap if no items need it
            if (giftWrapInCart) {
                await this.#updateCartItem(
                    window.rpCritical.giftWrapId.toString(),
                    0
                );
            }
            return;
        }

        if (giftWrapInCart?.quantity === giftWrapsNeeded) return;

        if (giftWrapInCart) {
            await this.#updateCartItem(
                window.rpCritical.giftWrapId.toString(),
                giftWrapsNeeded
            );
        } else {
            await this.#addToCart(
                window.rpCritical.giftWrapId,
                giftWrapsNeeded
            );
        }
    }

    #hideGiftWrapProduct() {
        const giftCardItem = document.querySelector(
            `[data-variant-id="${window.rpCritical.giftWrapId}"]`
        );
        if (giftCardItem) {
            giftCardItem.style.display = "none !important";
        }
    }

    #validateQuantity(event) {
        const input = event.target;
        const value = parseInt(input.value) || 1;
        const maxInventory = parseInt(input.dataset.inventory) || 0;
        const inventoryPolicy = input.dataset.inventoryPolicy;
        const inventoryManagement = input.dataset.inventoryManagement;

        let newValue = value;

        // Ensure minimum value of 1
        if (value < 1) {
            newValue = 1;
        }

        // Check stock limits
        if (
            inventoryManagement === "shopify" &&
            inventoryPolicy !== "continue" &&
            value > maxInventory
        ) {
            newValue = Math.max(1, maxInventory);
        }

        input.value = newValue;
        this.#updateButtonStates(input);

        // Trigger immediate update on blur
        const key = input.dataset.key;
        const quantity = parseInt(input.value) || 1;
        this.#cancelDebounce(key);
        this.#updateCartItem(key, quantity);

        return value >= 1;
    }

    #updateButtonStates(input) {
        const currentValue = parseInt(input.value) || 1;
        const maxInventory = parseInt(input.dataset.inventory) || 0;
        const inventoryPolicy = input.dataset.inventoryPolicy;
        const inventoryManagement = input.dataset.inventoryManagement;
        const cartItem = input.closest(".cart-item");
        const minusButton = cartItem.querySelector(
            ".cart-item__quantity-btn--minus"
        );
        const plusButton = cartItem.querySelector(
            ".cart-item__quantity-btn--plus"
        );

        if (minusButton) {
            minusButton.disabled = currentValue <= 1;
            minusButton.dataset.quantity = Math.max(1, currentValue - 1);
        }

        if (plusButton) {
            const atStockLimit =
                inventoryManagement === "shopify" &&
                inventoryPolicy !== "continue" &&
                currentValue >= maxInventory;

            plusButton.disabled = atStockLimit;

            if (!atStockLimit) {
                plusButton.dataset.quantity = currentValue + 1;
            }
        }
    }

    async #handleQuantityChange(event) {
        const input = event.target;
        const cartItem = input.closest(".cart-item");
        const giftCheckbox = cartItem.querySelector(
            '.cart-item__gift_checkbox input[type="checkbox"]'
        );
        const hasGiftWrap = giftCheckbox?.checked;

        if (!this.#validateQuantity(event)) return;

        const quantity = parseInt(input.value) || 1;
        const key = input.dataset.key;

        this.#cancelDebounce(key);

        try {
            await this.#updateCartItem(key, quantity, hasGiftWrap, false);
            
            if (hasGiftWrap) {
                await this.#fetchCart();
                await this.#updateGiftWrapQuantity();
            }
            
            window.location.reload();
        } catch (error) {
            console.error("Failed to update quantity:", error);
            this.#showError("Error actualizando la cantidad");
        }
    }

    async #handleQuantityButton(event) {
        const button = event.target.closest(".cart-item__quantity-btn");
        if (!button) return;

        const key = button.dataset.key;
        const cartItem = button.closest(".cart-item");
        const input = cartItem.querySelector(".cart-item__quantity-input");
        const giftCheckbox = cartItem.querySelector(
            '.cart-item__gift_checkbox input[type="checkbox"]'
        );
        const hasGiftWrap = giftCheckbox?.checked;
        const isPlus = button.classList.contains(
            "cart-item__quantity-btn--plus"
        );
        const currentValue = parseInt(input.value) || 1;
        const maxInventory = parseInt(input.dataset.inventory) || 0;
        const inventoryPolicy = input.dataset.inventoryPolicy;
        const inventoryManagement = input.dataset.inventoryManagement;

        let newValue;
        if (isPlus) {
            if (
                inventoryPolicy === "continue" ||
                inventoryManagement !== "shopify"
            ) {
                newValue = currentValue + 1;
            } else {
                newValue = Math.min(currentValue + 1, maxInventory);
            }
        } else {
            newValue = Math.max(1, currentValue - 1);
        }

        input.value = newValue;
        this.#updateButtonStates(input);

        this.#cancelDebounce(key);

        try {
            await this.#updateCartItem(key, newValue, hasGiftWrap, false);
            
            if (hasGiftWrap) {
                await this.#fetchCart();
                await this.#updateGiftWrapQuantity();
            }
            
            window.location.reload();
        } catch (error) {
            console.error("Failed to update quantity:", error);
            this.#showError("Error actualizando la cantidad");
        }
    }

    async #handleRemoveItem(event) {
        const button = event.target.closest(".cart-item__remove");
        if (!button) return;

        const key = button.dataset.key;
        const cartItem = button.closest(".cart-item");
        const hasGiftWrap = cartItem.querySelector(
            '.cart-item__gift_checkbox input[type="checkbox"]'
        )?.checked;

        cartItem.style.opacity = "0.5";
        cartItem.style.pointerEvents = "none";

        this.#cancelDebounce(key);

        try {
            await this.#updateCartItem(key, 0, false, "remove");
            await this.#fetchCart();

            if (hasGiftWrap) {
                await this.#updateGiftWrapQuantity();
            }

            window.location.reload();
        } catch (error) {
            console.error("Failed to remove item:", error);
            this.#showError("Error removing item");
        }
    }

    #debounceUpdate(key, quantity) {
        this.#cancelDebounce(key);

        const timeoutId = setTimeout(async () => {
            const cartItem = document.querySelector(`[data-key="${key}"]`);
            const giftCheckbox = cartItem?.querySelector(
                '.cart-item__gift_checkbox input[type="checkbox"]'
            );
            const hasGiftWrap = giftCheckbox?.checked;

            try {
                await this.#updateCartItem(key, quantity, hasGiftWrap, false);
                
                if (hasGiftWrap) {
                    await this.#fetchCart();
                    await this.#updateGiftWrapQuantity();
                }
                
                window.location.reload();
            } catch (error) {
                console.error("Failed to update quantity:", error);
                this.#showError("Error actualizando la cantidad");
            }

            this.updateTimeouts.delete(key);
        }, this.debounceDelay);

        this.updateTimeouts.set(key, timeoutId);
    }

    #cancelDebounce(key) {
        const timeoutId = this.updateTimeouts.get(key);
        if (timeoutId) {
            clearTimeout(timeoutId);
            this.updateTimeouts.delete(key);
        }
    }

    async #addToCart(variantId, quantity) {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity,
            }),
        });

        if (!response.ok) throw new Error("Error añadiendo al carrito");
    }

    async #updateCartItem(key, quantity, isGift = false, shouldReload = true) {
        const cartItem = document.querySelector(`[data-key="${key}"]`);
        const updateButtons = document.querySelectorAll(
            ".cart-page__update-btn"
        );

        for (const button of updateButtons) {
            button.disabled = true;
        }

        if (cartItem) {
            cartItem.classList.add("cart-item--updating");
        }

        try {
            const response = await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    id: key,
                    quantity: quantity,
                    properties: {
                        _update_via: "ajax",
                        Regalo: isGift ? "Sí" : "No",
                    },
                }),
            });

            if (!response.ok) throw new Error("Failed to update cart");

            const updatedCart = await response.json();
            this.cart = updatedCart;

            if (cartItem) {
                cartItem.style.opacity = "";
                cartItem.style.pointerEvents = "";
                cartItem.classList.remove("cart-item--updating");
            }

            for (const button of updateButtons) {
                button.disabled = false;
            }

            // Only reload if it's a remove action or explicitly requested
            if (shouldReload && (quantity === 0)) {
                window.location.reload();
            }

            return updatedCart;
        } catch (error) {
            console.error("Cart update failed:", error);
            this.#showError(
                "Ocurrió un error al actualizar el carrito, intenta de nuevo."
            );
            throw error;
        }
    }
  
    async #clearCart() {
        try {
            const response = await fetch("/cart/clear.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            });

            if (!response.ok) throw new Error("Failed to clear cart");

            this.cart = { items: [] };
            window.location.reload();
        } catch (error) {
            console.error(error);
            this.#showError("Ocurrió un error");
        }
    }

    #showError(message) {
        let errorElement = document.querySelector(".cart-page__error");

        if (!errorElement) {
            errorElement = document.createElement("div");
            errorElement.className = "cart-page__error";
            const header = document.querySelector(".cart-page__header");
            if (header) {
                header.insertAdjacentElement("afterend", errorElement);
            }
        }

        errorElement.textContent = message;
        errorElement.style.display = "block";

        // Auto-hide after 5 seconds
        setTimeout(() => {
            if (errorElement) {
                errorElement.style.display = "none";
            }
        }, 5000);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new CartPage();
});
